const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_slash_or_bash = function (actor, battleState, normalAttackNode) {
  const node = new TreeNode(actor, battleState, normalAttackNode);

  // branch indexes
  const BASH = 0;
  const SLASH = 1;
  const NORMAL_ATTACK = 2;

  node.branches[NORMAL_ATTACK] = normalAttackNode; // this should be Q_most_single_target_damage

  if (BattleCalc.getEquippedAbility(actor, 'slash')) {
    node.branches[SLASH] = new UseAbility(actor, 'slash');
  } else {
    node.branches[SLASH] = node.branches[NORMAL_ATTACK];
  }

  if (BattleCalc.getEquippedAbility(actor, 'bash')) {
    node.branches[BASH] = new UseAbility(actor, 'bash');
  } else {
    node.branches[BASH] = node.branches[NORMAL_ATTACK];
  }

  node.query = function (target) {
    // only branches 1 or 2 (slash or normal attack
    var _chance = Math.floor(1 + Math.random() * 2);

    if (
      !BattleCalc.getCondition(target, 'stunned') &&
      !BattleCalc.getCondition(target, 'liberated')
    ) {
      // equal chance of any branch
      _chance = Math.floor(Math.random() * 3);
    }

    return this.branches[_chance].query(target);
  };

  return node;
};
module.exports = Q_slash_or_bash;
